<mat-dialog-content>
  <div class="dialog-content-container">
    <div class="dialog-title text-center mb-4">{{ title }}</div>

    <!-- Search Section -->
    <div class="search-section mb-3">
      <mat-form-field floatLabel="always" appearance="outline" class="w-100 search-field">
        <mat-label>Search by Voucher Code or Name</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput
               [(ngModel)]="searchTerm"
               (keydown.enter)="search($event)"
               type="text"
               [disabled]="isSearching"
               placeholder="Enter voucher code or name">
        <button mat-icon-button matSuffix
                *ngIf="searchTerm && !isSearching"
                (click)="searchTerm = ''; searchResults = []; hasSearched = false;">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-icon matSuffix *ngIf="isSearching">
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      </mat-form-field>
      <div class="d-flex gap-2 mt-1">
        <button class="btn btn-outline-primary btn-sm flex-grow-1" (click)="search()" [disabled]="isSearching">
          <i class="fa fa-search me-1"></i> Search
        </button>
        <button class="btn btn-outline-secondary btn-sm flex-grow-1" (click)="showAll()" [disabled]="isSearching">
          <i class="fa fa-list me-1"></i> Show All Active
        </button>
      </div>
    </div>

    <!-- Search Results as Cards -->
    <div *ngIf="searchResults.length > 0 && !selectedVoucher" class="search-results mb-3">
      <h6 class="text-muted mb-2">Available Vouchers ({{ searchResults.length }})</h6>
      <div class="results-list">
        <div *ngFor="let v of searchResults"
             class="voucher-card p-3 mb-2 border rounded"
             [class.eligible]="v.eligible"
             [class.ineligible]="!v.eligible"
             (click)="selectVoucher(v)">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div>
              <span class="badge bg-primary me-2">{{ v.code }}</span>
              <span class="fw-bold">{{ v.name }}</span>
            </div>
            <span class="badge" [class.bg-success]="v.eligible" [class.bg-secondary]="!v.eligible">
              {{ getTypeLabel(v) }}
            </span>
          </div>
          <div class="d-flex gap-3 flex-wrap small">
            <span *ngIf="v.minimumSpend > 0" class="text-muted">
              <i class="fa fa-tag"></i> Min spend: RM {{ v.minimumSpend | number:'1.2-2' }}
            </span>
            <span *ngIf="v.usageRemaining != null" class="text-muted">
              <i class="fa fa-repeat"></i> {{ v.usageRemaining }} uses left
            </span>
            <span *ngIf="v.startDate || v.endDate" class="text-muted">
              <i class="fa fa-calendar"></i>
              {{ v.startDate || '...' }} - {{ v.endDate || 'No expiry' }}
            </span>
          </div>
          <div *ngIf="v.eligible" class="mt-2">
            <span class="text-success fw-bold">Discount: - RM {{ v.calculatedDiscount | number:'1.2-2' }}</span>
          </div>
          <div *ngIf="!v.eligible" class="mt-2">
            <span class="text-danger small"><i class="fa fa-exclamation-circle me-1"></i>{{ v.ineligibleReason }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Selected Voucher Display -->
    <div class="selected-voucher py-3 px-3 highlight-background rounded mb-3" *ngIf="selectedVoucher">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <span class="badge bg-primary me-2 fs-6">{{ selectedVoucher.code }}</span>
          <span class="fw-bold fs-5">{{ selectedVoucher.name }}</span>
        </div>
        <button class="btn btn-sm btn-outline-secondary" (click)="clearSelection()">
          <i class="fa fa-times"></i> Change
        </button>
      </div>

      <div class="badge bg-info text-dark mb-3">{{ getTypeLabel(selectedVoucher) }}</div>

      <div *ngIf="freeItemName" class="alert alert-info py-2 mb-2">
        <i class="fa fa-gift me-1"></i> Free item: <strong>{{ freeItemName }}</strong>
      </div>

      <hr class="my-2">

      <div class="deduction-info">
        <div class="row mb-2">
          <div class="col-6"><span class="text-muted">Order Total:</span></div>
          <div class="col-6 text-end"><span class="fw-semibold">RM {{ data.totalAmount | number:'1.2-2' }}</span></div>
        </div>
        <div class="row mb-2">
          <div class="col-6"><span class="text-success fw-bold">Voucher Discount:</span></div>
          <div class="col-6 text-end"><span class="fw-bold text-success fs-5">- RM {{ voucherAmount | number:'1.2-2' }}</span></div>
        </div>
        <div class="row" *ngIf="remainingAmount > 0">
          <div class="col-6"><span class="text-warning fw-bold">Remaining to Pay:</span></div>
          <div class="col-6 text-end"><span class="fw-bold text-warning fs-5">RM {{ remainingAmount | number:'1.2-2' }}</span></div>
        </div>
        <div class="row" *ngIf="remainingAmount <= 0">
          <div class="col-12 text-center">
            <span class="text-success fw-bold"><i class="fa fa-check-circle me-1"></i> Full amount covered by voucher</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state text-center py-5" *ngIf="!hasSearched && searchResults.length === 0 && !selectedVoucher">
      <mat-icon class="empty-icon mb-3" style="font-size: 48px; width: 48px; height: 48px; color: #ccc;">local_offer</mat-icon>
      <p class="text-muted">Search for a voucher or click "Show All Active" to browse</p>
    </div>

    <!-- No Results -->
    <div class="text-center py-4" *ngIf="hasSearched && searchResults.length === 0 && !selectedVoucher && !isSearching">
      <p class="text-muted">No vouchers found. Try a different search or click "Show All Active".</p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons-container d-flex justify-content-center w-100 p-3">
    <div class="cancel-button-container col-4 me-3">
      <button class="btn btn-light border-0 fw-semibold mb-0 d-block py-3 w-100" (click)="cancel()">
        <i class="fa fa-times-circle me-2"></i><span>Cancel</span>
      </button>
    </div>
    <div class="action-button-container col-8">
      <button *ngIf="!selectedVoucher"
        class="btn btn-primary text-white w-100 h-100 d-flex align-items-center justify-content-center py-3"
        (click)="search()"
        [disabled]="isSearching">
        <span>{{ isSearching ? 'Searching...' : 'Search' }}</span>
      </button>
      <button *ngIf="selectedVoucher"
        class="btn btn-success text-white w-100 h-100 d-flex align-items-center justify-content-center py-3"
        (click)="submit()"
        [disabled]="voucherAmount <= 0">
        <i class="fa fa-check-circle me-2"></i><span>Apply Voucher</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
